import styled from "styled-components";
import designSystemColors from "../../styles";

export const InputWithErrorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Label = styled.label`
  font-size: 14px;
  color: #00000085;
  font-weight: 300;
  letter-spacing: 0%;
`;

export const RequiredSpan = styled.span`
  color: ${designSystemColors.errorColor};
`;

export const ErrorMessage = styled.span`
  display: block;
  font-size: 12px;
  color: ${designSystemColors.errorColor};
`;
